import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    queuedStatus: (progressType: string) => string;
    paused: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Status label when transfer is queued, varies by transfer type */
            queuedStatus: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (progressType: string): string => __intl__.intl().formatMessage({ id: "QueuedJobStatus.queuedStatus?c=3eglzobb8047v", defaultMessage: "{progressType, select, DOWNLOAD {Download queued} RENDER {Export queued} other {Upload queued}}" }, { progressType: progressType }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status label when transfer is paused */
            paused: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QueuedJobStatus.paused?c=ylas17etod9r", defaultMessage: "Paused" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
